import React from "react";
import { useParams } from "react-router-dom";
import { Heading } from "@chakra-ui/react";

import { Layout } from "./PageLayouts";
import { useGetDbUser, useGetModulesByUser } from "@hooks";
import { UserDetails, Loading, ModuleGrid } from "@components";

export function UserPage() {
  const { userId } = useParams();
  const maybeUserId = React.useMemo(() => (userId ? userId : ""), [userId]);
  const [dbUser, { update: updateDbUser }] = useGetDbUser(maybeUserId);
  const { documents: modulesByUser } = useGetModulesByUser(maybeUserId);
  return (
    <Layout isProtected>
      {userId && dbUser && modulesByUser ? (
        <>
          <UserDetails
            userId={userId}
            userDetails={dbUser}
            updateUser={updateDbUser}
          />
          {modulesByUser.length > 0 ? (
            <>
              <Heading paddingTop="16px" size="lg">
                Contributed to {modulesByUser.length} Modules:
              </Heading>
              <ModuleGrid modules={modulesByUser} />
            </>
          ) : undefined}
        </>
      ) : (
        <Loading />
      )}
    </Layout>
  );
}
